webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(891),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(893),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3070bf28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(896),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4913f3d7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutUs__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AboutUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AboutUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Bot__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Bot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Bot__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/about',
    name: 'About Us',
    component: __WEBPACK_IMPORTED_MODULE_3__components_AboutUs___default.a
  }, {
    path: '/bot',
    name: 'Our Bot',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Bot___default.a
  }]
}));

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(894),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 44 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-particles',
  props: {
    color: {
      type: String,
      default: '#dedede'
    },
    particleOpacity: {
      type: Number,
      default: 0.7
    },
    particlesNumber: {
      type: Number,
      default: 80
    },
    shapeType: {
      type: String,
      default: 'circle'
    },
    particleSize: {
      type: Number,
      default: 4
    },
    linesColor: {
      type: String,
      default: '#dedede'
    },
    linesWidth: {
      type: Number,
      default: 1
    },
    lineLinked: {
      type: Boolean,
      default: true
    },
    lineOpacity: {
      type: Number,
      default: 0.4
    },
    linesDistance: {
      type: Number,
      default: 150
    },
    moveSpeed: {
      type: Number,
      default: 3
    },
    hoverEffect: {
      type: Boolean,
      default: true
    },
    hoverMode: {
      type: String,
      default: 'grab'
    },
    clickEffect: {
      type: Boolean,
      default: true
    },
    clickMode: {
      type: String,
      default: 'push'
    }
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__(92);
    this.$nextTick(function () {
      _this.initParticleJS(_this.color, _this.particleOpacity, _this.particlesNumber, _this.shapeType, _this.particleSize, _this.linesColor, _this.linesWidth, _this.lineLinked, _this.lineOpacity, _this.linesDistance, _this.moveSpeed, _this.hoverEffect, _this.hoverMode, _this.clickEffect, _this.clickMode);
    });
  },

  methods: {
    initParticleJS: function initParticleJS(color, particleOpacity, particlesNumber, shapeType, particleSize, linesColor, linesWidth, lineLinked, lineOpacity, linesDistance, moveSpeed, hoverEffect, hoverMode, clickEffect, clickMode) {
      particlesJS('particles-js', {
        "particles": {
          "number": {
            "value": particlesNumber,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": color
          },
          "shape": {
            "type": shapeType,
            "stroke": {
              "width": 0,
              "color": "#192231"
            },
            "polygon": {
              "nb_sides": 5
            }
          },
          "opacity": {
            "value": particleOpacity,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": particleSize,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 40,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": lineLinked,
            "distance": linesDistance,
            "color": linesColor,
            "opacity": lineOpacity,
            "width": linesWidth
          },
          "move": {
            "enable": true,
            "speed": moveSpeed,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": hoverEffect,
              "mode": hoverMode
            },
            "onclick": {
              "enable": clickEffect,
              "mode": clickMode
            },
            "onresize": {

              "enable": true,
              "density_auto": true,
              "density_area": 400

            }
          },
          "modes": {
            "grab": {
              "distance": 140,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      });
    }
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Navs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_typer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_typer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_typer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//Imports important page elements


//Imports main Vue components in


//Imports db constant from src/components/firebase.js


//Import Footer

//Material CSS imported here





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_typer___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutUs',
  components: {
    Navs: __WEBPACK_IMPORTED_MODULE_1__Navs___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a
  }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_typer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_typer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_typer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//Imports important page elements


//Imports main Vue components in


//Imports db constant from src/components/firebase.js


//Material CSS imported here





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_typer___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Bot',
  components: {
    Navs: __WEBPACK_IMPORTED_MODULE_0__Navs___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a
  },
  data: function data() {
    return {
      showMessage: false
    };
  },

  methods: {}
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//Imports db constant from src/components/firebase.js


//Imports Material CSS



// let opportunityRef = db.ref('Mumbai')
//   let pos = []
// opportunityRef.on('value', function(snapshot) {

//   pos.push(snapshot.val())
// });

// console.log(pos)


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'featured',

  //defines empty thing really important
  data: function data() {
    return {
      positions: [],
      recent_positions: []
    };
  },

  firebase: {
    positions: {
      source: __WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* db */].ref('Mumbai'),
      // Optional, allows you to handle any errors.
      cancelCallback: function cancelCallback(err) {
        console.error(err);
      }
    }
  },
  computed: {
    reverse: function reverse() {
      return this.positions.reverse().slice(0, 6);
    }
  }

});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import VuePaginator from 'vuejs-paginator'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_material___default.a);

// console.log(Vue.$children)
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon___default.a
  }
  //defines empty thing really important

});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Featured__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Featured___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Featured__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_typer__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_typer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_typer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_particles__ = __webpack_require__(900);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//Imports important page elements





//Imports main Vue components in


//Imports db constant from src/components/firebase.js


//Material CSS imported here





__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_typer___default.a);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_material___default.a);


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_particles__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    Navs: __WEBPACK_IMPORTED_MODULE_0__Navs___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_1__Search___default.a,
    Featured: __WEBPACK_IMPORTED_MODULE_2__Featured___default.a,
    Footer: __WEBPACK_IMPORTED_MODULE_3__Footer___default.a,
    'vue-typer': __WEBPACK_IMPORTED_MODULE_8_vue_typer__["VueTyper"]
  }
});

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export auth */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: "AIzaSyCCN3USnjztk1GcnrHVScsyRvedRdpI7YQ",
  authDomain: "vue-trial-1.firebaseapp.com",
  databaseURL: "https://vue-trial-1.firebaseio.com",
  projectId: "vue-trial-1",
  storageBucket: "vue-trial-1.appspot.com",
  messagingSenderId: "136352030230"
});

var auth = firebaseApp.auth();
var db = firebaseApp.database();

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    toggleLeftSidenav: function toggleLeftSidenav() {
      this.$refs.leftSidenav.toggle();
    },
    toggleRightSidenav: function toggleRightSidenav() {
      this.$refs.rightSidenav.toggle();
    },
    closeRightSidenav: function closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    open: function open(ref) {
      console.log('Opened: ' + ref);
    },
    close: function close(ref) {
      console.log('Closed: ' + ref);
    }
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner_src_components_Circle8_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner_src_components_Circle8_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner_src_components_Circle8_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import VuePaginator from 'vuejs-paginator'


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);

var mumbaiRef = __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* db */].ref('Mumbai');

var oppArray = [];

var query = mumbaiRef.orderByKey();

query.once("value").then(function (snapshot) {
  snapshot.forEach(function (childSnapshot) {
    var oppKey = childSnapshot.key;
    var address = childSnapshot.child('Address').val();
    var organisation = childSnapshot.child('Organisation').val();
    var category = childSnapshot.child('Category').val();
    var commitment = childSnapshot.child('Commitment').val();
    var form = childSnapshot.child('Form').val();
    var description = childSnapshot.child('Description').val();
    var city = childSnapshot.child('City').val();
    // oppArray.push({'Organisation':organisation, 'Category': category, 'Commitment':commitment, 'Form':form, 'Description':description, oppKey})
    // oppArray.push(oppKey)
    oppArray.push({ address: address, organisation: organisation, category: category, commitment: commitment, form: form, description: description, city: city, oppKey: oppKey });
  });
  //console.log(oppArray)
});
// console.log(oppArray)

// console.log(Vue.$children)
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  components: {
    Circle8: __WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner_src_components_Circle8_vue___default.a
  },
  //defines empty thing really important
  data: function data() {
    return {
      results: {},
      searchString: ''

    };
  },

  methods: {
    greet: function greet(event) {
      document.getElementById('preloader').style.display = 'block';
      this.results = [];
      setTimeout(this.afterLoading, 3000);
    },
    afterLoading: function afterLoading() {

      document.getElementById('preloader').style.display = 'none';

      var options = {
        shouldSort: true,
        threshold: 0.3,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["address", "description", "organisation", "city", "category"]

      };

      var fuse = new __WEBPACK_IMPORTED_MODULE_1_fuse_js___default.a(oppArray, options); // "list" is the item array
      this.results = fuse.search(this.searchString);
      document.getElementById('hideBtn').style.display = 'block';
    },
    clear: function clear(event) {
      this.results = [];
      document.getElementById('hideBtn').style.display = 'none';
      // document.getElementById('heading').style.display = 'none';
      this.searchString = '';
    }
  }

});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_firebase__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  // created() {
  //   // configured routes for login
  //   auth.onAuthStateChanged((user) => {
  //     if(user) {
  //       this.$router.push('/success')
  //     } else {
  //       this.$router.push('/')
  //     }
  //    })
  //   },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(892),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21bc64bb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(899),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(895),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4673f102",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(889),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01a1538a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(890),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01c2e7ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(897),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cf6ea1b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(62)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(898),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6be25538",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 889:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#fffff"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "EnderBar"
  }, [_c('h1', [_vm._v("Talk to me on ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto 0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-official",
      "scale": "5"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('message', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage),
      expression: "showMessage"
    }],
    staticClass: "tr pop-up-message"
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("This is Header")]), _vm._v(" "), _c('span', {
    slot: "body"
  }, [_vm._v("This is Body")])])], 1), _vm._v(" "), (!_vm.showMessage) ? _c('div', {
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMessage = true
      }
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_vm._v("Primary")])]) : (_vm.showMessage) ? _c('div', {
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMessage = false
      }
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_vm._v("Primary")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('h1', [_vm._v("WorkTeen Bot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid FirstBar"
  }, [_c('div', {
    staticClass: "col-md-12 row "
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 "
  }, [_c('h1', [_vm._v("\nHey guys\n")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-6 col-xs-10 checkBar",
    staticStyle: {
      "align": "center"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid secondBar"
  }, [_c('div', {
    staticClass: "col-md-12 row "
  }, [_c('div', {
    staticClass: "col-md-5 col-sm-12 col-xs-12 "
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25%"
    }
  }, [_vm._v("\nFeatures\n")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 checkBar2"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid thirdBar"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-7 col-sm-12 col-xs-12 checkBar3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-sm-12 col-xs-12 "
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25%"
    }
  }, [_vm._v("\nFeatures\n")])])])])
}]}

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured"
  }, [_c('div', {
    staticClass: "row results-row"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.reverse), function(pos) {
    return _c('div', {
      staticClass: "col-md-offset-2 col-md-8 col-xs-10 col-xs-offset-1"
    }, [_c('md-card', {
      staticClass: "md-primary",
      attrs: {
        "flex": "",
        "md-with-hover": "",
        "md-elevation": "15"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Work with " + _vm._s(pos.Organisation))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                    Commitment: " + _vm._s(pos.Commitment)), _c('br'), _vm._v("\n                    Work in " + _vm._s(pos.City) + " "), _c('br'), _vm._v("\n                    Category: " + _vm._s(pos.Category) + "\n                                      ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
      staticClass: "theme",
      attrs: {
        "href": pos.Form,
        "target": "_blank"
      }
    }, [_vm._v("Apply")]), _vm._v(" "), _c('md-button', {
      staticClass: "theme",
      attrs: {
        "md-expand-trigger": ""
      }
    }, [_vm._v("\n                      More Info\n                    ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    })], 1), _vm._v(" "), _c('md-card-content', [_vm._v(" \n                    " + _vm._s(pos.Description) + "\n                  ")])], 1)], 1)], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " col-md-12 col-xs-12"
  }, [_c('h3', {
    staticClass: "title-text text-center"
  }, [_vm._v(" Recent Opportunities ")])])
}]}

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-8",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-container"
  }, [_c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_1"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_3"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "contener_mixte"
  }, [_c('div', {
    staticClass: "ballcolor ball_4"
  }, [_vm._v(" ")])])])
}]}

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-toolbar', {
    staticClass: "md-transparent"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1)], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large navEdit"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h1', {
    staticClass: "navHeading"
  }, [_vm._v(" WorkTeen"), _c('hr', {
    staticClass: "navHR"
  })])])]), _vm._v(" "), _c('div', [_c('md-list', [_c('md-list-item', [_c('md-icon', [_vm._v("home")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("people")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About Us")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("android")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/bot"
    }
  }, [_vm._v("Our Bot")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all"
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "mainPage"
  }, [_c('header', {
    staticClass: "col-md-12"
  }, [_c('Navs'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('md-button', {
    staticClass: "button"
  }, [_c('md-icon', [_vm._v("expand_more")])], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "ourTeam col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase2"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Kunal Mishra")]), _vm._v(" "), _c('h4', [_vm._v("Co-founder")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/kunal-mishra-a2056574/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase1"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Aayush Chadha")]), _vm._v(" "), _c('h4', [_vm._v("Co-founder")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/aayush-c-970566107/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: " md-large increase4"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Utsav Gupta")]), _vm._v(" "), _c('h4', [_vm._v("Data Collection Team, Delhi")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/utsav22g/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase5"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Anubhav Ghosh")]), _vm._v(" "), _c('h4', [_vm._v("Front-end Developer")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/anubhav-ghosh-50609314b/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/anubhavg8/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "ourWork"
  })])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-md-offset-2 briefText"
  }, [_c('h1', {
    staticClass: "mainHeader"
  }, [_vm._v("Who We Are ")]), _vm._v(" "), _c('h3', [_vm._v(" WorkTeen is an initiative to help high school students across various Indian cities find internships, volunteering and research opportunities. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "padding-left": "5%",
      "padding-right": "5%"
    }
  }, [_c('h1', {
    staticClass: "col-md-12 heading"
  }, [_vm._v("\r\n              About WorkTeen\r\n              "), _c('hr', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "5%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_vm._v("\r\n                We work with non governmental organisations, various firms and research institutes to help high school students dicover new passions and contribute towards the community.")]), _c('p', {
    staticClass: "content1"
  }, [_vm._v(" We are constantly on the look out for new opportunities and if you are in a position to help us expand our opportunities, we will love to talk to you. ")]), _c('p', {
    staticClass: "content1"
  }, [_vm._v("You can leave us your contact details by messaging on our social media channels. Either way, a member of our team will get in touch with you at the earliest.\r\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "heading"
  }, [_vm._v("The WorkTeen Team\r\n        "), _c('hr', {
    staticClass: "col-md-3"
  })])
}]}

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center text-center center-lg"
  }, [_c('div', {
    staticClass: "col-lg-5 col-xs-12"
  }, [_c('div', {
    staticClass: "container-fluid text-center"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "https://www.facebook.com/workteen/",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "https://twitter.com/teen_work?lang=en",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "mailto:opportunities.workteen@outlook.com",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-lg-2 col-xs-3 text-center"
  }, [_c('a', {
    staticClass: "btn btn-info social-button",
    attrs: {
      "href": "http://www.workteen.org",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-12 col-xs-12"
  }, [_c('strong', [_c('p', {
    staticStyle: {
      "margin-top": "3%",
      "font-size": "1.2em"
    }
  }, [_vm._v("Made with "), _c('icon', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "red"
    },
    attrs: {
      "name": "heart",
      "scale": "1"
    }
  }), _vm._v(" by the WorkTeen Team.")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-12 col-xs-12"
  }, [_c('strong', [_c('p', {
    staticStyle: {
      "margin-top": "6%",
      "font-size": "1.5em"
    }
  }, [_vm._v("Thoughts? Connect with us.")])])])])
}]}

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('Navs'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "col-md-12",
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('vue-particles', {
    attrs: {
      "color": "#1d3557",
      "particleOpacity": 0.4,
      "particlesNumber": 45,
      "shapeType": "star",
      "particleSize": 4,
      "linesColor": "#05668d",
      "linesWidth": 1,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "hoverEffect": false,
      "hoverMode": "grab",
      "clickMode": "push"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fullPage"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticClass: "title-text col-md-12"
  }, [_vm._v("WorkTeen")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h5'), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "line-height": "1.1"
    }
  }, [_vm._v("Connecting people to opportunities. Search for "), _c('vue-typer', {
    attrs: {
      "text": ["Intern", "Volunteer", "Mumbai", "Food", "Media", "Teaching", "Computers", "Bangalore", "Design", "Write"],
      "repeat": Infinity,
      "shuffle": false,
      "initial-action": "typing",
      "pre-type-delay": 70,
      "type-delay": 70,
      "pre-erase-delay": 2000,
      "erase-delay": 250,
      "erase-style": "select-all",
      "erase-on-complete": false,
      "caret-animation": "blink"
    }
  })], 1)]), _vm._v(" "), _c('Search')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {}
  }, [_c('Featured')], 1)]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-10 col-xs-10 col-xs-offset-1"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "id": "search",
      "placeholder": "Search for internships, positions and just about anything"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.greet($event)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('md-button', {
    staticClass: "search-btn",
    on: {
      "click": _vm.greet
    }
  }, [_vm._v("SEARCH")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row col-md-4 col-xs-3  col-md-offset-5 col-sm-offset-5 col-xs-offset-4",
    staticStyle: {
      "display": "none",
      "float": "left"
    },
    attrs: {
      "id": "preloader"
    }
  }, [_c('div', {
    staticClass: "col-md-offset-1"
  }, [_c('circle8', {
    attrs: {
      "size": "100px"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.results), function(index) {
    return _c('div', {
      staticClass: "search-result col-lg-4 col-md-6 col-xs-12"
    }, [_c('md-card', {
      staticClass: "md-primary",
      staticStyle: {},
      attrs: {
        "flex": "",
        "md-with-hover": "",
        "md-elevation": "15"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(index.organisation))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                Commitment: " + _vm._s(index.commitment) + " "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                City: " + _vm._s(index.city) + " "), _c('br')])]), _vm._v(" "), _c('md-card-expand', {
      staticClass: "margT"
    }), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
      staticClass: "theme",
      attrs: {
        "href": index.form,
        "target": "_blank"
      }
    }, [_vm._v("Apply")]), _vm._v(" "), _c('md-button', {
      staticClass: "theme",
      attrs: {
        "md-expand-trigger": ""
      }
    }, [_vm._v("\n                  More Info\n                ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "flex": "1"
      }
    })], 1), _vm._v(" "), _c('md-card-content', [_vm._v("\n                  " + _vm._s(index.description) + "\n              ")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini md-clean md-fab-bottom-right",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hideBtn"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "particles-js",
      "color": _vm.color,
      "particleOpacity": _vm.particleOpacity,
      "linesColor": _vm.linesColor,
      "particlesNumber": _vm.particlesNumber,
      "shapeType": _vm.shapeType,
      "particleSize": _vm.particleSize,
      "linesWidth": _vm.linesWidth,
      "lineLinked": _vm.lineLinked,
      "lineOpacity": _vm.lineOpacity,
      "linesDistance": _vm.linesDistance,
      "moveSpeed": _vm.moveSpeed,
      "hoverEffect": _vm.hoverEffect,
      "hoverMode": _vm.hoverMode,
      "clickEffect": _vm.clickEffect,
      "clickMode": _vm.clickMode
    }
  })
},staticRenderFns: []}

/***/ })

},[52]);


// WEBPACK FOOTER //
// static/js/app.80d29e9806fb6e8573c4.js